export const ListState = ({ loading, isEmpty, loadingText = "Loading...", emptyText = "Nothing found.", children }) => {
  if (loading) return <div className="text-center py-12 text-[#F2EDE4]/30" data-testid="list-loading">{loadingText}</div>;
  if (isEmpty) return <div className="text-center py-12 text-[#F2EDE4]/30" data-testid="list-empty">{emptyText}</div>;
  return children;
};

export default ListState;
